export default class LoginException extends Error {
  maxAttempts;
  numberOfPasswordAttempt;
  activateCaptcha;

  constructor(body) {
    super(body.message);
    if ((body.maxAttempts && body.numberOfPasswordAttempt) || body.activateCaptcha) {
      this.maxAttempts = body.maxAttempts;
      this.activateCaptcha = body.activateCaptcha;
      this.numberOfPasswordAttempt = body.numberOfPasswordAttempt;
    }
  }
}
